import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

const BASE_INPUT_CLASS =
  "h-12 rounded-xl pl-10 text-sm leading-normal placeholder:text-foreground/50"

export function IconInputField({
  form,
  name,
  label,
  icon: Icon,
  labelAddon,
  inputClassName,
  ...inputProps
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {labelAddon ? (
            <div className="flex items-center justify-between">
              <FormLabel className="text-sm font-semibold text-foreground">{label}</FormLabel>
              {labelAddon}
            </div>
          ) : (
            <FormLabel className="text-sm font-semibold text-foreground">{label}</FormLabel>
          )}
          <div className="relative">
            <Icon className="pointer-events-none absolute left-3 top-1/2 z-10 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <FormControl>
              <Input
                data-1p-ignore
                data-lpignore="true"
                className={cn(BASE_INPUT_CLASS, inputClassName)}
                {...field}
                {...inputProps}
              />
            </FormControl>
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
